export default "__VITE_ASSET__DGHRLacT__"